module.exports = __webpack_public_path__ + "static/heros3-260b9c0c616f7e2e8b757cccbc48cacc.jpeg";